import React from 'react'
import { Modal, Stack } from '~/components/_layouts'
import { Button } from '~/components/_atoms/index'

const CloseReviewDialog = ({
  toggleDialog,
  showConfirmDeleteDialog,
  deleteCoachNote,
}) => {
  const confirmDelete = () => deleteCoachNote()
  return (
    <Modal
      title={
        <Stack direction="row" spacing={2}>
          Are you sure you want to delete this review?
        </Stack>
      }
      size="md"
      open={showConfirmDeleteDialog}
      onClose={toggleDialog}
      actions={
        <div className="flex w-full gap-4">
          <Button onClick={confirmDelete}>Delete Review</Button>
          <Button onClick={toggleDialog} variant="outline">
            Cancel
          </Button>
        </div>
      }
    >
      This action cannot be undone. Are you sure you want to delete this review?
    </Modal>
  )
}

export default CloseReviewDialog
